import { selector } from 'recoil';

import { viewState } from '@internal/window/atom';

const MEDIUM_SIZE_LIMIT = 800;

export enum Orientation {
  Landscape = "landscape",
  Portrait = "portrait",
}

export enum Size {
  Small = "small",
  Medium = "medium",
  Large = "large",
}

type ViewSelectorType = {
  orientation: Orientation;
  size: Size;
};

export const viewTypeSelector = selector<ViewSelectorType>({
  key: 'ViewTypeSelector',
  get: ({ get }) => {
    const { height, width } = get(viewState);
    const orientation = width >= height
      ? Orientation.Landscape
      : Orientation.Portrait;

    let size = Size.Medium;
    if (width < MEDIUM_SIZE_LIMIT) {
      size = Size.Small;
    }

    return { orientation, size };
  },
});